interface FilterRowProps {
  label: string;
  options: string[];
  value: string;
  onChange: (value: string) => void;
}

export default function FilterRow({ label, options, value, onChange }: FilterRowProps) {
  const allOptions = ["全部", ...options];

  return (
    <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4 py-3 border-b border-background-200 last:border-b-0">
      <span className="text-sm text-foreground-500 shrink-0 w-16 pt-1">{label}</span>
      <div className="flex flex-wrap gap-2">
        {allOptions.map((option) => {
          const active = option === value;
          return (
            <button
              key={option}
              type="button"
              onClick={() => onChange(option)}
              className={`px-3 py-1.5 rounded-md text-sm transition-colors cursor-pointer whitespace-nowrap ${
                active
                  ? "bg-primary-500 text-background-50 font-medium"
                  : "bg-background-200 text-foreground-700 hover:bg-background-300 hover:text-foreground-950"
              }`}
            >
              {option}
            </button>
          );
        })}
      </div>
    </div>
  );
}